import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AISecurityPage from "@/pages/service/AISecurityPage";

export const Route = createFileRoute("/service/ai-security")({
  head: () => pageHead("AI Security & Assurance", "AI red teaming, model robustness testing, bias detection, and governance frameworks for secure, trustworthy AI systems.", "/service/ai-security", false),
  component: AISecurityPage,
});
